import { apiClient, assertOk, csrfHeaders, jsonHeaders } from '@api/common'
import {
  type AuthSession,
  type LoginPayload,
  type LoginResult,
  type PasswordChangePayload,
  type PasswordChangeResult,
} from '@app-types/api/auth'

export async function loadAuthSession() {
  const response = await apiClient.get<AuthSession>('/api/auth/session/')

  assertOk(response, 'Unable to load auth session')

  return response.data
}

export async function loginAuthSession(
  payload: LoginPayload,
  csrfToken: string,
) {
  const response = await apiClient.post<LoginResult>(
    '/api/auth/login/',
    payload,
    {
      headers: jsonHeaders(csrfToken),
    },
  )

  if (response.status === 403) {
    return {
      success: false,
      error: 'csrf_failed',
    }
  }

  const result = response.data

  if (response.status < 200 || response.status >= 300) {
    return {
      success: false,
      error: result?.error || 'login_failed',
    }
  }

  return result
}

export async function logoutAuthSession(csrfToken: string) {
  const response = await apiClient.post<{ success: boolean }>(
    '/api/auth/logout/',
    null,
    {
      headers: csrfHeaders(csrfToken),
    },
  )

  assertOk(response, 'Unable to logout')

  return response.data
}

export async function changeAuthPassword(
  payload: PasswordChangePayload,
  csrfToken: string,
) {
  const response = await apiClient.post<PasswordChangeResult>(
    '/api/auth/password-change/',
    {
      old_password: payload.oldPassword ?? '',
      new_password1: payload.newPassword1,
      new_password2: payload.newPassword2,
    },
    {
      headers: jsonHeaders(csrfToken),
    },
  )
  const result = response.data

  if (response.status < 200 || response.status >= 300) {
    return result
  }

  return result
}
